var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"10px"}},_vm._l((_vm.packages),function(p){return _c('PackageListItem',{key:p.id,attrs:{"package-item":p}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }